import { IconButton, MenuItem, Tooltip } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import { MoreVert } from '@material-ui/icons';
import * as React from 'react';
import ConfirmMenuItem from './ConfirmMenuItem/ConfirmMenuItem';
import { IMenuItem } from './ESDataTable';

export interface IESMenuProps {
    menuItems: IMenuItem[];
}

export default class ESMenu extends React.Component<IESMenuProps> {
    public state = {
        anchorEl: null,
        isOpen: false,
    };

    public toggleIsOpen = (event: React.MouseEvent) => {
        event.stopPropagation();
        let anchorEl = null;
        if (!this.state.isOpen) {
            anchorEl = event.currentTarget;
        }
        this.setState({ anchorEl, isOpen: !this.state.isOpen });
    };

    public onMenuItemClick = (item: IMenuItem) => (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        if (!item.disabled) {
            this.setState({ anchorEl: null, isOpen: false });
            return item.onClick(event);
        }
    };
    public onMouseLeave = (item: IMenuItem) => (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        this.setState({ anchorEl: null, isOpen: false });
        return item.onMouseLeave!(event);
    };

    public render() {
        const menuItems: React.ReactNode[] = [];
        this.props.menuItems.forEach((item: IMenuItem, idx: number) => {
            if (item.isConfirm) {
                menuItems.push(
                    <ConfirmMenuItem
                        key={idx}
                        onClick={this.onMenuItemClick(item)}
                        onMouseLeave={this.onMouseLeave(item)}
                        disabled={item.disabled}
                    >
                        {item.name}
                    </ConfirmMenuItem>
                );
            } else {
                menuItems.push(this.generateMenuItem(item, idx));
            }
        });
        return (
            <>
                <IconButton onClick={this.toggleIsOpen}>
                    <MoreVert />
                </IconButton>
                <Menu
                    anchorEl={this.state.anchorEl}
                    open={this.state.isOpen}
                    onClose={this.toggleIsOpen}
                    transformOrigin={{
                        horizontal: 'center',
                        vertical: 'top',
                    }}
                >
                    {menuItems}
                </Menu>
            </>
        );
    }

    public generateMenuItem(item: IMenuItem, idx: number) {
        const menuItem = (
            <MenuItem
                button
                key={idx}
                onClick={this.onMenuItemClick(item)}
                style={item.disabled ? { cursor: 'default', opacity: 0.5 } : {}}
            >
                {item.name}
            </MenuItem>
        );
        if (item.tooltip) {
            return (
                <Tooltip title={item.tooltip}>
                    <div>{menuItem}</div>
                </Tooltip>
            );
        }
        return menuItem;
    }
}



// WEBPACK FOOTER //
// ./src/common/ESMenu.tsx